import { a as e } from "./index-Dvb-FM3N.js";
class s {
  /**
   * Permission required for publishing a dataset to a data room.
   */
  static leafCrud(t) {
    return e.Permission.create({
      leafCrudPermission: { leafNodeId: t }
    });
  }
  /**
   * Permission required for retrieving a data room's definition after
   * it has been published.
   */
  static get retrieveDataRoom() {
    return e.Permission.create({
      retrieveDataRoomPermission: {}
    });
  }
  /**
   * Permission for retrieving the audit log, a log detailing all past
   * interactions with the data room.
   */
  static get retrieveAuditLog() {
    return e.Permission.create({
      retrieveAuditLogPermission: {}
    });
  }
  /**
   * Permission for executing the computation with the given name.
   */
  static executeCompute(t) {
    return e.Permission.create({
      executeComputePermission: { computeNodeId: t }
    });
  }
  /**
   * Permission for retrieving the computation result with the given name.
   */
  static retrieveComputeResult(t) {
    return e.Permission.create({
      retrieveComputeResultPermission: { computeNodeId: t }
    });
  }
  /**
   * Permission for retrieving the status of a data room.
   */
  static get retrieveDataRoomStatus() {
    return e.Permission.create({
      retrieveDataRoomStatusPermission: {}
    });
  }
  /**
   * Permission for updating the status of a data room
   * (e.g. irreversibly stopping it).
   */
  static get updateDataRoomStatus() {
    return e.Permission.create({
      updateDataRoomStatusPermission: {}
    });
  }
  /**
   * Permission for retrieving the list of datasets that has been
   * published to the data room.
   */
  static get retrievePublishedDatasets() {
    return e.Permission.create({
      retrievePublishedDatasetsPermission: {}
    });
  }
  /**
   * Permission for triggering a dry run on the data room.
   */
  static get dryRun() {
    return e.Permission.create({
      dryRunPermission: {}
    });
  }
  /**
   * Permission for generating signatures required for merge approvals.
   */
  static get generateMergeSignature() {
    return e.Permission.create({
      generateMergeSignaturePermission: {}
    });
  }
  /**
   * Permission for executing computations in development mode.
   */
  static get executeDevelopmentCompute() {
    return e.Permission.create({
      executeDevelopmentComputePermission: {}
    });
  }
  /**
   * Permission for merging configuration commits into the current data
   * room configuration.
   */
  static get mergeConfigurationCommit() {
    return e.Permission.create({
      mergeConfigurationCommitPermission: {}
    });
  }
}
export {
  s as Permissions
};
//# sourceMappingURL=permission.js.map
